import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { addToast } from 'containers/Toasts/actions'

import {
  editTenantApplyError,
  editTenantApplySuccess,
  fetchTenantDataError,
  fetchTenantDataSuccess,
} from './actions'
import { EDIT_TENANT_APPLY_ASYNC,FETCH_TENANT_DATA } from './constants'
import { selectRelatedAddons } from './selectors'

const fetchTenantDataEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(FETCH_TENANT_DATA.INITIATE).switchMap((action) =>
    api.msp
      .fetchTenantData(action.payload.tenantId)
      .map((response) => fetchTenantDataSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(fetchTenantDataError, error, [400])))
  )

const editTenantEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(EDIT_TENANT_APPLY_ASYNC.INITIATE).switchMap((action) => {
    const addonsToEdit = { ...store.getState().partner.editTenant.mapSelectedAddons }
    const relatedAddons = selectRelatedAddons(store.getState())
    relatedAddons.map((addon) => {
      addonsToEdit[addon] = true
    })

    const { enableDmarcForPartnersProps, ...data } = store.getState().partner.editTenant.data

    return api.msp
      .editTenant(action.payload.tenantId, {
        ...data,
        enableDmarcForPartners: enableDmarcForPartnersProps?.visible ? enableDmarcForPartnersProps?.value : undefined,
        addons: addonsToEdit,
      })
      .switchMap((response) =>
        Observable.of(
          editTenantApplySuccess(response),
          addToast({ message: `Tenant ${action.payload.tenantName} was updated successfully!` })
        )
      )
      .catch((error) =>
        Observable.of(
          epicsErrorHandler(editTenantApplyError, error, [400]),
          addToast({
            message: (
              <div>
                We were unable to update the tenant {action.payload.tenantName}.
                <br />
                <br />
              </div>
            ),
            type: 'error',
            button: {
              text: 'Contact Customer Success',
              onClick: () =>
                window.open('https://support.ironscales.com/hc/en-us/requests/new', '_blank'),
            },
          })
        )
      )
  })

export default combineEpics(fetchTenantDataEpic, editTenantEpic)
